import React, { lazy, Suspense, useEffect, useState } from "react";
import BookDisplay from "./components/BookDisplay";
import PopularAuthor from "./components/PopularAuthor";
import BookCollection from "./components/BookCollection";
import Footer from "../../common/UI/Footer";
import EbookCategoriesCarousel from "./components/EbookCategoriesCarousel";
import OverlayReading from "./components/OverlayReading";
import { useCategories } from "../../hooks/categories/useCategories";
import Loading from "../../common/HousGlass Loader/Loading";
import OverlayHome from "../../Homepage/components/OverlayHome";
import styles from "../../Homepage/HomePageMain.module.css";
import BlogSwipper from "../../Blogs/BlogsSwipper";
import { Helmet } from "react-helmet";
import { getPageMetaById } from '../../api/PageMetaManager';

function ReadingHome() {
    const { categories, isLoading, isError, error } = useCategories(
      "Ebook",
      "english"
    );

    const [meta, setMeta] = useState({
      title: "",
      description: "",
      keywords: ""
    });
  
    useEffect(() => {
      const fetchMeta = async () => {
        try {
          const data = await getPageMetaById(5)
          setMeta({
            title: data.meta_title || '',
            description: data.meta_description || '',
            keywords: data.meta_keywords || ''
          });
        } catch (error) {
          console.warn('Meta not found for home page, using defaults');
        }
      };
  
      fetchMeta();
    }, []);

  // Render loading state
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "300px",
        }}
      >
        <Loading />
      </div>
    );
  }

  // Handle error state
  if (isError) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
        Error loading categories:{" "}
        {error?.message || "An unknown error occurred"}
      </div>
    );
  }

  return (
    <>
    <Helmet>
      <title>{meta.title || 'English Readings - SunoKahaniyan'}</title>
      <meta
        name="description"
        content={
          meta.description ||
          'Explore a wide range of English ebooks and readings on SunoKahaniyan. Discover trending collections, recently added content, and much more!'
        }
      />
      <meta name="keywords" content={meta.keywords || 'audio stories, ebooks, videos, hindi kahaniyan, suno kahaniyan'} />
    </Helmet>
      <OverlayHome type={"EnglishReadings"} category={"book"} />
      <div className={`${styles.homepageContainer} ${styles.contentOverlap}`}>
        <BookDisplay languageName={"english"} />

        {/* Dynamically render carousel components for each category */}
        {categories && categories.length > 0 ? (
          <>
            {categories.map((category, index) => (
              <React.Fragment key={category.id}>
                <EbookCategoriesCarousel
                  categoryName={category.name}
                  categorySlug={category.slug}
                />
                {/* Render BlogsComponent after Science Fiction category */}
                {category.name === "Science Fiction" && <BlogSwipper />}
              </React.Fragment>
            ))}
          </>
        ) : (
          <div style={{ padding: "20px", textAlign: "center" }}>
            No categories available
          </div>
        )}

        <BookCollection />
        <Footer />
      </div>
    </>
  );
}

export default ReadingHome;